import { render, staticRenderFns } from "./registers-for-gen-approver-report.vue?vue&type=template&id=4b0222fb&lang=pug&"
import script from "./registers-for-gen-approver-report.vue?vue&type=script&lang=ts&"
export * from "./registers-for-gen-approver-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports